module.exports = __webpack_public_path__ + "static/img/download_bg_tmp.ecc2f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_tmp.jpg
// module id = B9E5
// module chunks = 1